(function () {
  'use strict';

  var page = document.querySelector('.registration-page');
  if (!page) return;

  /* ─── Step definitions ─── */
  var STEPS = [
    { id: 'about-you', title: 'About You' },
    { id: 'skin-type', title: 'Your Skin Type & Tone' },
    { id: 'concerns', title: 'Primary Skin Concerns' },
    { id: 'acne', title: 'Acne Deep Dive', condition: 'acne' },
    { id: 'pigmentation', title: 'Hyperpigmentation Deep Dive', condition: 'pigmentation' },
    { id: 'hair', title: 'Hair & Scalp', condition: 'hair' },
    { id: 'medical', title: 'Medical History & Safety' },
    { id: 'routine', title: 'Current Routine' },
    { id: 'goals', title: 'Goals & Expectations' },
    { id: 'consent', title: 'Consent & Data' }
  ];

  var currentStepIndex = 0;
  var activeSteps = [];

  var progressCounter = page.querySelector('[data-progress-counter]');
  var progressTitle = page.querySelector('[data-progress-title]');
  var progressFill = page.querySelector('[data-progress-fill]');
  var nav = page.querySelector('[data-reg-nav]');
  var btnBack = nav.querySelector('[data-action="back"]');
  var btnNext = nav.querySelector('[data-action="next"]');

  /* ─── Condition helpers ─── */
  function getCheckedConcerns() {
    var checked = page.querySelectorAll('[name="q_concerns[]"]:checked');
    var values = [];
    checked.forEach(function (el) { values.push(el.value); });
    return values;
  }

  function hasAcneConcern() {
    var c = getCheckedConcerns();
    return c.indexOf('acne') !== -1 || c.indexOf('pih') !== -1;
  }

  function hasPigmentationConcern() {
    var c = getCheckedConcerns();
    return c.indexOf('hyperpigmentation') !== -1 || c.indexOf('pih') !== -1 || c.indexOf('melasma') !== -1;
  }

  function hasHairConcern() {
    var radio = page.querySelector('[name="q_hair_concerns"]:checked');
    return radio && radio.value === 'yes';
  }

  function conditionMet(condition) {
    if (!condition) return true;
    if (condition === 'acne') return hasAcneConcern();
    if (condition === 'pigmentation') return hasPigmentationConcern();
    if (condition === 'hair') return hasHairConcern();
    return true;
  }

  /* ─── Compute active steps based on current selections ─── */
  function computeActiveSteps() {
    activeSteps = [];
    for (var i = 0; i < STEPS.length; i++) {
      if (conditionMet(STEPS[i].condition)) {
        activeSteps.push(STEPS[i]);
      }
    }
  }

  /* ─── Primary concern dropdown ─── */
  var concernLabels = {
    hyperpigmentation: 'Hyperpigmentation / dark spots / uneven skin tone',
    pih: 'Post-inflammatory hyperpigmentation (PIH)',
    acne: 'Acne (active breakouts)',
    acne_scarring: 'Acne scarring',
    melasma: 'Melasma / hormonal pigmentation',
    dry_dehydrated: 'Dry or dehydrated skin',
    oily_congested: 'Oily / congested skin',
    enlarged_pores: 'Enlarged pores',
    dullness: 'Dullness / lack of radiance',
    fine_lines: 'Fine lines and early ageing',
    eczema_psoriasis: 'Eczema or psoriasis',
    razor_bumps: 'Razor bumps / ingrown hairs',
    keloid: 'Keloid or raised scarring',
    dark_circles: 'Dark circles / under-eye concerns',
    texture: 'Skin texture / rough patches'
  };

  function updatePrimaryConcernDropdown() {
    var select = page.querySelector('[name="q_primary_concern"]');
    if (!select) return;
    var current = select.value;
    var checked = getCheckedConcerns();

    // Clear options except placeholder
    while (select.options.length > 1) select.remove(1);

    checked.forEach(function (val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = concernLabels[val] || val;
      select.appendChild(opt);
    });

    // Restore previous selection if still valid
    if (checked.indexOf(current) !== -1) {
      select.value = current;
    }
  }

  // Listen for concern checkbox changes
  page.querySelectorAll('[name="q_concerns[]"]').forEach(function (cb) {
    cb.addEventListener('change', updatePrimaryConcernDropdown);
  });

  /* ─── Navigation ─── */
  function getStepEl(stepId) {
    return page.querySelector('[data-step-id="' + stepId + '"]');
  }

  function goTo(index) {
    computeActiveSteps();

    if (index < 0 || index > activeSteps.length) return;

    // Validate before advancing
    if (index > currentStepIndex) {
      if (!validateStep(activeSteps[currentStepIndex].id)) return;
    }

    currentStepIndex = index;

    // Show/hide steps
    var allSteps = page.querySelectorAll('.reg-step');
    allSteps.forEach(function (el) { el.classList.remove('reg-step--active'); });

    if (currentStepIndex >= activeSteps.length) {
      // Success screen
      var successEl = getStepEl('success');
      if (successEl) successEl.classList.add('reg-step--active');
      page.classList.add('is-complete');
      nav.style.display = 'none';
    } else {
      var step = activeSteps[currentStepIndex];
      var stepEl = getStepEl(step.id);
      if (stepEl) stepEl.classList.add('reg-step--active');

      // Update progress
      progressCounter.textContent = 'Section ' + (currentStepIndex + 1) + ' of ' + activeSteps.length;
      progressTitle.textContent = step.title;
      var pct = (currentStepIndex / activeSteps.length) * 100;
      progressFill.style.width = pct + '%';

      // Update nav
      btnBack.toggleAttribute('hidden', currentStepIndex === 0);

      if (currentStepIndex === activeSteps.length - 1) {
        btnNext.innerHTML = 'Submit questionnaire <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M5 12h14m-7-7l7 7-7 7"/></svg>';
      } else {
        btnNext.innerHTML = 'Continue <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M5 12h14m-7-7l7 7-7 7"/></svg>';
      }
    }

    page.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  btnNext.addEventListener('click', function () {
    computeActiveSteps();
    if (currentStepIndex === activeSteps.length - 1) {
      submitQuestionnaire();
    } else {
      goTo(currentStepIndex + 1);
    }
  });

  btnBack.addEventListener('click', function () {
    goTo(currentStepIndex - 1);
  });

  /* ─── Validation ─── */
  function validateStep(stepId) {
    clearErrors();

    switch (stepId) {
      case 'about-you':
        return requireField('q_first_name', 'Please enter your first name.')
            && requireField('q_email', 'Please enter your email address.')
            && validateEmail()
            && validateDob();

      case 'skin-type':
        return requireRadio('q_fitzpatrick', 'Please select your skin tone.')
            && requireRadio('q_midday_skin', 'Please select how your skin feels by midday.');

      case 'concerns':
        var checked = getCheckedConcerns();
        if (checked.length === 0) {
          showError('q_concerns', 'Please select at least one concern.');
          return false;
        }
        var primary = page.querySelector('[name="q_primary_concern"]').value;
        if (!primary) {
          showError('q_primary_concern', 'Please select your primary concern.');
          return false;
        }
        return true;

      case 'goals':
        return requireField('q_one_change', 'Please tell us your #1 priority.');

      case 'consent':
        var required = ['q_consent_age', 'q_consent_location', 'q_consent_gdpr', 'q_consent_accuracy'];
        var allChecked = true;
        for (var i = 0; i < required.length; i++) {
          var cb = page.querySelector('[name="' + required[i] + '"]');
          if (!cb || !cb.checked) {
            showError('q_consent', 'Please confirm all required items marked with *.');
            allChecked = false;
            break;
          }
        }
        return allChecked;
    }

    return true;
  }

  function validateEmail() {
    var input = page.querySelector('[name="q_email"]');
    if (!input) return true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim())) {
      showError('q_email', 'Please enter a valid email address.');
      return false;
    }
    return true;
  }

  function validateDob() {
    var day = page.querySelector('[name="q_dob_day"]').value;
    var month = page.querySelector('[name="q_dob_month"]').value;
    var year = page.querySelector('[name="q_dob_year"]').value;
    if (!day || !month || !year) {
      showError('q_dob', 'Please select your full date of birth.');
      return false;
    }
    var dob = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    var today = new Date();
    var age = today.getFullYear() - dob.getFullYear();
    var m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
    if (age < 18) {
      showError('q_dob', 'You must be at least 18 years old.');
      return false;
    }
    return true;
  }

  function requireField(name, msg) {
    var input = page.querySelector('[name="' + name + '"]');
    if (!input || !input.value.trim()) {
      showError(name, msg);
      return false;
    }
    return true;
  }

  function requireRadio(name, msg) {
    var checked = page.querySelector('[name="' + name + '"]:checked');
    if (!checked) {
      showError(name, msg);
      return false;
    }
    return true;
  }

  function showError(fieldName, msg) {
    var wrapper = page.querySelector('[data-field="' + fieldName + '"]');
    if (!wrapper) return;
    wrapper.classList.add('has-error');
    var errEl = wrapper.querySelector('.form-field__error');
    if (!errEl) {
      errEl = document.createElement('p');
      errEl.className = 'form-field__error';
      wrapper.appendChild(errEl);
    }
    errEl.textContent = msg;
    errEl.style.display = 'block';

    // Scroll to error
    wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearErrors() {
    page.querySelectorAll('.has-error').forEach(function (el) {
      el.classList.remove('has-error');
    });
    page.querySelectorAll('.form-field__error').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  /* ─── Collect all form data ─── */
  function collectFormData() {
    var data = {};

    // Text & email inputs
    page.querySelectorAll('input[type="text"], input[type="email"]').forEach(function (el) {
      if (el.name && el.value.trim()) data[el.name] = el.value.trim();
    });

    // Selects
    page.querySelectorAll('select').forEach(function (el) {
      if (el.name && el.value) data[el.name] = el.value;
    });

    // Textareas
    page.querySelectorAll('textarea').forEach(function (el) {
      if (el.name && el.value.trim()) data[el.name] = el.value.trim();
    });

    // Radio buttons
    page.querySelectorAll('input[type="radio"]:checked').forEach(function (el) {
      if (el.name) data[el.name] = el.value;
    });

    // Checkboxes (multi-select)
    var checkGroups = {};
    page.querySelectorAll('input[type="checkbox"]:checked').forEach(function (el) {
      if (!el.name) return;
      if (el.name.endsWith('[]')) {
        var key = el.name;
        if (!checkGroups[key]) checkGroups[key] = [];
        checkGroups[key].push(el.value);
      } else {
        data[el.name] = el.value;
      }
    });
    for (var key in checkGroups) {
      data[key] = checkGroups[key].join(', ');
    }

    return data;
  }

  /* ─── Build structured note from data ─── */
  function buildNote(data) {
    var lines = [];
    lines.push('=== SKIN CARE QUESTIONNAIRE ===');
    lines.push('Submitted: ' + new Date().toISOString());
    lines.push('');

    lines.push('--- ABOUT YOU ---');
    lines.push('Name: ' + (data.q_first_name || '') + ' ' + (data.q_last_name || ''));
    lines.push('DOB: ' + (data.q_dob_day || '') + '/' + (data.q_dob_month || '') + '/' + (data.q_dob_year || ''));
    lines.push('Email: ' + (data.q_email || ''));
    lines.push('Location: ' + (data.q_location || ''));
    lines.push('Referral: ' + (data.q_referral || ''));
    lines.push('Previous consultation: ' + (data.q_previous_consultation || ''));
    lines.push('');

    lines.push('--- SKIN TYPE & TONE ---');
    lines.push('Fitzpatrick: ' + (data.q_fitzpatrick || ''));
    lines.push('Midday skin: ' + (data.q_midday_skin || ''));
    lines.push('Product reaction: ' + (data.q_product_reaction || ''));
    lines.push('Sensitivity: ' + (data.q_sensitivity || ''));
    lines.push('');

    lines.push('--- PRIMARY CONCERNS ---');
    lines.push('Concerns: ' + (data['q_concerns[]'] || ''));
    lines.push('Primary: ' + (data.q_primary_concern || ''));
    lines.push('Hair concerns: ' + (data.q_hair_concerns || ''));
    lines.push('');

    if (hasAcneConcern()) {
      lines.push('--- ACNE DEEP DIVE ---');
      lines.push('Duration: ' + (data.q_acne_duration || ''));
      lines.push('Location: ' + (data['q_acne_location[]'] || ''));
      lines.push('Type: ' + (data.q_acne_type || ''));
      lines.push('Treatments tried: ' + (data['q_acne_treatments[]'] || ''));
      lines.push('Period-related: ' + (data.q_acne_period || ''));
      lines.push('PCOS: ' + (data.q_acne_pcos || ''));
      lines.push('');
    }

    if (hasPigmentationConcern()) {
      lines.push('--- HYPERPIGMENTATION DEEP DIVE ---');
      lines.push('Onset: ' + (data.q_pigment_onset || ''));
      lines.push('Sun-related: ' + (data.q_pigment_sun || ''));
      lines.push('Lightening products: ' + (data.q_pigment_products || ''));
      lines.push('Reactions: ' + (data.q_pigment_reactions || ''));
      lines.push('SPF usage: ' + (data.q_spf_usage || ''));
      lines.push('SPF product: ' + (data.q_spf_product || ''));
      lines.push('');
    }

    if (hasHairConcern()) {
      lines.push('--- HAIR & SCALP ---');
      lines.push('Concerns: ' + (data['q_hair_concern[]'] || ''));
      lines.push('Hair type: ' + (data.q_hair_type || ''));
      lines.push('Practices: ' + (data['q_hair_practices[]'] || ''));
      lines.push('Loss duration: ' + (data.q_hair_loss_duration || ''));
      lines.push('Loss area: ' + (data.q_hair_loss_area || ''));
      lines.push('Conditions: ' + (data['q_hair_conditions[]'] || ''));
      lines.push('Pregnancy: ' + (data.q_hair_pregnancy || ''));
      lines.push('Blood tests: ' + (data['q_hair_blood_tests[]'] || ''));
      lines.push('Stressors: ' + (data.q_hair_stressors || ''));
      lines.push('');
    }

    lines.push('--- MEDICAL HISTORY ---');
    lines.push('Pregnant/breastfeeding: ' + (data.q_pregnant || ''));
    lines.push('Planning pregnancy: ' + (data.q_planning_pregnancy || ''));
    lines.push('Conditions: ' + (data['q_medical_conditions[]'] || ''));
    lines.push('Other conditions: ' + (data.q_medical_other || ''));
    lines.push('Medications: ' + (data.q_medications || ''));
    lines.push('Allergies: ' + (data.q_allergies || ''));
    lines.push('Adverse reactions: ' + (data.q_adverse_reactions || ''));
    lines.push('');

    lines.push('--- CURRENT ROUTINE ---');
    lines.push('Morning: ' + (data.q_morning_routine || ''));
    lines.push('Evening: ' + (data.q_evening_routine || ''));
    lines.push('Budget: ' + (data.q_budget || ''));
    lines.push('Where buy: ' + (data['q_where_buy[]'] || ''));
    lines.push('Prescription tried: ' + (data['q_prescription_tried[]'] || ''));
    lines.push('');

    lines.push('--- GOALS & EXPECTATIONS ---');
    lines.push('Good skin: ' + (data.q_good_skin || ''));
    lines.push('One change: ' + (data.q_one_change || ''));
    lines.push('Consistency: ' + (data.q_consistency || ''));
    lines.push('Routine time: ' + (data.q_routine_time || ''));
    lines.push('Open to prescription: ' + (data.q_open_prescription || ''));
    lines.push('');

    lines.push('--- CONSENT ---');
    lines.push('Age confirmed: ' + (data.q_consent_age || 'no'));
    lines.push('Location confirmed: ' + (data.q_consent_location || 'no'));
    lines.push('GDPR consent: ' + (data.q_consent_gdpr || 'no'));
    lines.push('Follow-up consent: ' + (data.q_consent_followup || 'no'));
    lines.push('Accuracy confirmed: ' + (data.q_consent_accuracy || 'no'));

    return lines.join('\n');
  }

  /* ─── Submit ─── */
  function submitQuestionnaire() {
    if (!validateStep('consent')) return;

    var web3formsKey = page.dataset.web3formsKey;
    if (!web3formsKey) {
      showError('q_consent', 'Form is not configured. Please contact the site administrator.');
      return;
    }

    var data = collectFormData();
    var note = buildNote(data);
    var firstName = (data.q_first_name || '').trim();
    var fullName = firstName + ' ' + (data.q_last_name || '');

    btnNext.disabled = true;
    btnNext.textContent = 'Submitting...';

    // Submit via Web3Forms API
    var payload = {
      access_key: web3formsKey,
      subject: 'Skin Care Questionnaire - ' + fullName,
      from_name: 'Brandlistry Questionnaire',
      name: fullName,
      email: data.q_email || '',
      message: note,
      // Key fields for quick reference in email
      skin_tone: data.q_fitzpatrick || '',
      primary_concern: data.q_primary_concern || '',
      location: data.q_location || ''
    };

    // Send to Google Sheet (fire-and-forget, don't block submission)
    var sheetUrl = page.dataset.googleSheetUrl;
    if (sheetUrl) {
      var sheetData = Object.assign({}, data, {
        submitted_at: new Date().toISOString(),
        full_name: fullName
      });
      var formBody = Object.keys(sheetData).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(sheetData[key]);
      }).join('&');
      fetch(sheetUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody,
        mode: 'no-cors'
      }).catch(function () { /* silent – email is the primary record */ });
    }

    fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (res) { return res.json(); })
    .then(function (result) {
      if (result.success) {
        var nameEl = page.querySelector('[data-summary-name]');
        if (nameEl) nameEl.textContent = firstName;
        progressFill.style.width = '100%';
        goTo(activeSteps.length);
      } else {
        showError('q_consent', result.message || 'Something went wrong. Please try again.');
        btnNext.disabled = false;
        btnNext.textContent = 'Submit questionnaire';
      }
    })
    .catch(function () {
      showError('q_consent', 'Network error. Please check your connection and try again.');
      btnNext.disabled = false;
      btnNext.textContent = 'Submit questionnaire';
    });
  }

  /* ─── Initialize ─── */
  computeActiveSteps();
  btnBack.setAttribute('hidden', '');
  progressCounter.textContent = 'Section 1 of ' + activeSteps.length;
  progressTitle.textContent = activeSteps[0].title;
})();
